(function () {
  const container = document.querySelector('.editorial-chaos-js');
  if (!container) return;

  const items = Array.from(container.querySelectorAll('a'));

  /* 0️⃣ Szöveg: eredeti + nagy kezdőbetű */
  items.forEach(el => {
    const t = el.textContent.trim();
    if (!t) return;
    el.textContent = t.charAt(0).toUpperCase() + t.slice(1);
  });

  /* 1️⃣ Csoportosítás */
  const pools = {
    big:   items.filter(el => Number(el.dataset.weight) >= 5),
    mid:   items.filter(el => [3,4].includes(Number(el.dataset.weight))),
    small: items.filter(el => Number(el.dataset.weight) <= 2)
  };

  const isMobile = window.innerWidth <= 768;

  /* 2️⃣ Tipográfia */
  pools.big.forEach(el => {
    el.style.fontSize = isMobile ? '1.8rem' : '2.5rem';
    el.style.fontWeight = '500';
  });
  pools.mid.forEach(el => {
    el.style.fontSize = isMobile ? '1.4rem' : '2rem';
    el.style.fontWeight = '400';
  });
  pools.small.forEach(el => {
    el.style.fontSize = isMobile ? '1.1rem' : '1.5rem';
    el.style.fontWeight = '300';
  });

  /* 3️⃣ SZIGORÚ VÁLTAKOZÓ KEVERÉS
     – nem lehet két azonos méret egymás után */
  const result = [];
  let last = null;

  function remaining(type) {
    return pools[type].length;
  }

  function pickNext() {
    const options = ['big','mid','small']
      .filter(t => t !== last && remaining(t) > 0)
      .sort((a, b) => remaining(b) - remaining(a));

    if (!options.length) return null;
    return options[0];
  }

  while (
    remaining('big') ||
    remaining('mid') ||
    remaining('small')
  ) {
    const next = pickNext();
    if (!next) break;

    last = next;
    result.push(pools[next].shift());
  }

  /* 4️⃣ DOM frissítés */
  container.innerHTML = '';
  result.forEach(el => container.appendChild(el));
})();
